// src/components/Blocks/DataFromRSS/Edit.jsx
import React, { useEffect } from 'react';
import { SidebarPortal } from '@plone/volto/components';
import { withBlockExtensions } from '@plone/volto/helpers';
import RSSDataForm from './Data';
import RSSDataView from './View';
import Schema from './schema';

const RSSDataEdit = (props) => {
  const { data, onChangeBlock, block, selected } = props;
  const rssSchema = Schema(props);

  // Normalizza i dati con valori di default
  const normalizedData = {
    ...data,
    title: data.title ?? rssSchema.properties.title.default,
    cardStyle: data.cardStyle ?? rssSchema.properties.cardStyle.default,
    maxResults: data.maxResults ?? rssSchema.properties.maxResults.default,
    feedUrl: data.feedUrl ?? rssSchema.properties.feedUrl.default,
  };

  return (
    <>
      <RSSDataView {...props} data={normalizedData} />
      <SidebarPortal selected={selected}>
        <RSSDataForm
          key={block}
          data={normalizedData}
          block={block}
          onChangeBlock={onChangeBlock}
          blocksConfig={props.blocksConfig}
        />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(RSSDataEdit);